import { WalletsResponse } from '@/types/sso';
import { useEffect, useMemo } from 'react';
import { useSso } from '../providers/SSOProvider';

export interface UseWalletOptionsReturn {
    walletOptions: { label: string; value: number }[];
    walletDetails?: WalletsResponse;
}

const useWalletOptions = (selectedCurrency, selectedWalletId?): UseWalletOptionsReturn => {
    const { walletInfoApi } = useSso();

    const { data: wallets } = walletInfoApi;

    const walletOptions = useMemo(() => {
        return wallets
            ? wallets
                  .filter((wallet) => {
                      if (wallet.active && wallet.status !== 'pending') {
                          if (selectedCurrency?.value)
                              return wallet.supportedAssets.find(
                                  (asset) => asset.currencyId === selectedCurrency?.value
                              );
                          else return true;
                      }
                  })
                  //   .map((wallet) => {
                  //       const fourDigits = wallet.walletAddress?.slice(-4);

                  //       return {
                  //           label: `${wallet.friendlyName} ${fourDigits ? `****${fourDigits}` : ''}`,
                  //           value: wallet.walletId
                  //       };
                  //   })
                  .map((wallet) => ({
                      label: wallet.friendlyName,
                      value: wallet.walletId
                  }))
            : [];
    }, [wallets, selectedCurrency]);

    const walletDetails = useMemo(() => {
        return wallets?.find((info) => info.walletId === selectedWalletId?.value);
    }, [wallets, selectedWalletId]);

    useEffect(() => {
        walletInfoApi.mutate();
    }, []);

    return { walletOptions, walletDetails };
};

export default useWalletOptions;
